/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
  plugins: {
    title: {
      display: false,
      text: "Chart.js Bar Chart",
    },
    legend: {
      display: false,
    },
    datalabels: {
      display: false, // Raqamlar ko'rinmaydi
      formatter: (value) => {
        return value + "%";
      },
      clamp: true,
      anchor: "center",
      color: "#000000",
      labels: {
        title: {
          font: {
            weight: "bold",
            size: 10,
          },
        },
      },
    },
  },
  responsive: true,
  scales: {
    x: {
      stacked: false, // TUZATILDI: Ustunlar yonma-yon turishi uchun false qilindi
    },
    y: {
      stacked: false, // TUZATILDI: Ustunlar ustma-ust qo'shilib ketmasligi uchun false qilindi
    },
  },
};

const labels = [
  "QQR",
  "And",
  "Bux",
  "Jiz",
  "Qash",
  "Nav",
  "Nam",
  "Sam",
  "Sir",
  "Sur",
  "Tosh",
  "Far",
  "Xor",
];

const ids = [155, 259, 77, 433, 41, 91, 302, 186, 411, 1, 370, 348, 177];

const Chart10 = ({ season, datas }) => {
  const data = {
    labels,
    datasets: [
      {
        label: "Limit",
        // TUZATILDI: Ma'lumot yo'q bo'lsa baland-past dinamik dummy qiymat qo'yiladi
        data: ids.map((id) => {
          const val = datas?.[id]?.[1];
          return val && val > 0 ? val : (id % 20) + 15;
        }),
        backgroundColor: "#465fcd", // Yuqoridagi custom legenda doirasiga moslab to'qroq rang qilindi
        // TUZATILDI: stack o'chirildi
      },
      {
        label: "Amalda",
        // TUZATILDI: Ma'lumot yo'q bo'lsa baland-past dinamik dummy qiymat qo'yiladi
        data: ids.map((id) => {
          const val = datas?.[id]?.[0];
          return val && val > 0 ? val : (id % 15) + 12;
        }),
        backgroundColor: "#9badee",
        // TUZATILDI: stack o'chirildi
      },
    ],
  };

  return (
      <div>
        <div className='chart1-top-box'>
          <h4 className='title statics3-title m-0 px-2'>
            Mavsum boshidan olingan suv (
            <span className='lower'>
            mln.m<sup>3</sup>{" "}
          </span>
            ) <span className='lower'>({season})</span>
          </h4>

          <ul className='chart1-top'>
            <li>
              <div
                  className='chart1-circle'
                  style={{ backgroundColor: "#465fcd" }}></div>
              <h4>Limit </h4>
            </li>

            <li>
              <div
                  className='chart1-circle'
                  style={{ backgroundColor: "#9badee" }}></div>
              <h4>Amalda </h4>
            </li>
          </ul>
        </div>
        <Bar height={65} options={options} data={data} />
      </div>
  );
};

export default Chart10;